import React from "react";
import Header from "../components/Header/Header";
import BottomNav from "../components/BottomNav/BottomNav";
import { getBrandName } from "../common/brand";
export default function TermAndCondition() {
  const brandName = getBrandName();
  return (
    <>
    <Header />
      <div className="tc-page">
        <div className="tc-container">
          <div className="tc-faq">
            <p className="tc-main-title">
              <strong>{brandName} – Terms &amp; Conditions</strong>
            </p>

            <p className="tc-paragraph">
              By accessing or using {brandName}, you agree to the terms and
              conditions outlined below. Please read these rules carefully
              before using our platform.
            </p>

            <div className="tc-divider">________________________________________</div>

            <p className="tc-section-title">1. General Terms</p>
            <p className="tc-paragraph">{brandName} is an online entertainment platform. All games offered here are intended strictly for entertainment purposes.</p>
            <p className="tc-paragraph">•By creating an account or using our services, you confirm that you are 18 years of age or older.</p>
            <p className="tc-paragraph">• {brandName} reserves the right to modify, update, or change any rule or policy at any time without prior notice.</p>

            <div className="tc-divider">________________________________________</div>

            <p className="tc-section-title">2. Account Registration</p>
            <p className="tc-paragraph">•Each user is allowed to maintain only one account.</p>
            <p className="tc-paragraph">•Providing false information, fake numbers, or fraudulent documents may lead to account suspension or permanent closure.</p>
            <p className="tc-paragraph">•You are solely responsible for maintaining the security of your account credentials.</p>

            <div className="tc-divider">________________________________________</div>

            <p className="tc-section-title">3. Deposits &amp; Withdrawals</p>
            <p className="tc-paragraph">• Deposits must be made only through {brandName} official payment gateway.</p>
            <p className="tc-paragraph">• Third-party or unauthorized deposit/withdrawal methods are strictly prohibited.</p>
            <p className="tc-paragraph">• {brandName} is not responsible for issues caused by incorrect transaction information provided by the user.</p>
            <p className="tc-paragraph">• Verification documents may be required before processing a withdrawal.</p>

            <div className="tc-divider">________________________________________</div>

            <p className="tc-section-title">4. Bonuses &amp; Promotions</p>
            <p className="tc-paragraph">• Bonuses are subject to specific rules and wagering requirements.</p>
            <p className="tc-paragraph">• If any misuse or manipulation of bonuses is detected, the bonus may be revoked.</p>
            <p className="tc-paragraph">• {brandName} reserves the right to modify or discontinue any bonus offer at any time.</p>

            <div className="tc-divider">________________________________________</div>

            <p className="tc-section-title">5. Game Rules</p>
            <p className="tc-paragraph">• All games follow the rules and regulations set by the respective game provider.</p>
            <p className="tc-paragraph">• In case of technical issues or network disruptions, {brandName} will take appropriate action based on system logs.</p>
            <p className="tc-paragraph">• Any attempt to exploit bugs, software manipulation, or hacking will result in a permanent account ban.</p>

            <div className="tc-divider">________________________________________</div>

            <p className="tc-section-title">6. Fraud &amp; Illegal Activities</p>
            <p className="tc-paragraph">• Use of bots, multiple accounts, VPN abuse, or any form of fraudulent activity is strictly forbidden.</p>
            <p className="tc-paragraph">• If fraud is detected, the account will be permanently banned and the balance may be confiscated.</p>

            <div className="tc-divider">________________________________________</div>

            <p className="tc-section-title">7. Limitation of Liability</p>
            <p className="tc-paragraph">• {brandName} is not responsible for any financial loss incurred while playing on the platform.</p>
            <p className="tc-paragraph">• We are not liable for service interruptions caused by server issues, network failures, or third-party service problems.</p>

            <div className="tc-divider">________________________________________</div>

            <p className="tc-section-title">8. User Responsibilities</p>
            <p className="tc-paragraph">• The platform must be used lawfully and responsibly.</p>
            <p className="tc-paragraph">• Posting illegal, abusive, or spam content is strictly prohibited.</p>
            <p className="tc-paragraph">• You are responsible for your own account activity, transactions, and gameplay behavior.</p>

            <div className="tc-divider">________________________________________</div>

            <p className="tc-section-title">9. Policy Updates</p>
            <p className="tc-paragraph">• {brandName} may update the Terms &amp; Conditions at any time without prior notice.</p>
            <p className="tc-paragraph">• Continued use of the platform after changes means you accept the updated terms.</p>

            <div className="tc-divider">________________________________________</div>

            <p className="tc-section-title">10. Customer Support</p>
            <p className="tc-paragraph">
              For any questions, issues, or complaints, please contact our 24/7
              Live Support Team.
            </p>
          </div>
        </div>
      </div>

      <style>{`
        * {
          box-sizing: border-box;
        }

        .tc-page {
          min-height: 100vh;
          width: 100%;
          background: #070721;
          padding: 0;
        }

        .tc-container {
          width: 100%;
          max-width: 100%;
        }

        .tc-faq {
          padding: 14px 18px 28px;
        }

        .tc-main-title {
          margin: 0 0 22px;
          color: #ffffff;
          font-size: 15px;
          line-height: 1.5;
          font-weight: 700;
        }

        .tc-section-title {
          margin: 0 0 8px;
          color: #ffffff;
          font-size: 15px;
          line-height: 1.8;
          font-weight: 500;
        }

        .tc-paragraph {
          margin: 0 0 6px;
          color: #ffffff;
          font-size: 15px;
          line-height: 1.85;
          font-weight: 400;
          word-break: break-word;
        }

        .tc-divider {
          margin: 10px 0 10px;
          color: #ffffff;
          font-size: 15px;
          line-height: 1.3;
          letter-spacing: 0.3px;
          white-space: nowrap;
          overflow: hidden;
        }

        @media (max-width: 640px) {
          .tc-faq {
            padding: 12px 16px 24px;
          }

          .tc-main-title,
          .tc-section-title,
          .tc-paragraph,
          .tc-divider {
            font-size: 14px;
          }

          .tc-paragraph {
            line-height: 1.8;
          }
        }
      `}</style>
      <BottomNav />
    </>
  );
}